import { createSelector } from 'reselect'
import getTasteOfGoldPromoCampaign from 'takeovers/tasteOfGoldTakeover/selectors/getTasteOfGoldPromoCampaign'
import getOrderInternationalItemsTotal from './getOrderInternationalItemsTotal'
import { TASTE_OF_GOLD_MIN_PRICE } from 'takeovers/tasteOfGoldTakeover/constants/tasteOfGoldConstants'
import { getViewedOrder } from 'selectors/orderSelectors'

/**
 * Whether the viewed order qualifies for Taste of Gold benefits.
 * Requires the ToG campaign to be active and the combined international
 * accommodation total to meet the minimum price threshold.
 */
const getIsTasteOfGoldEligibleOrder = createSelector(
  (state: App.State) => getTasteOfGoldPromoCampaign(state),
  (state: App.State) => getOrderInternationalItemsTotal(state),
  (state: App.State) => getViewedOrder(state)?.currencyCode,
  (tasteOfGoldCampaign, internationalItemsTotal, currency): boolean => {
    return !!tasteOfGoldCampaign &&
      tasteOfGoldCampaign.available > 0 &&
      currency === 'AUD' &&
      internationalItemsTotal >= TASTE_OF_GOLD_MIN_PRICE
  },
)

export default getIsTasteOfGoldEligibleOrder
